import { Lang, localeOf } from '../../../../i18n';

// Date du mariage d'exemple affichée dans les animations (dayOffset : jours après).
export function exampleDate(lang: Lang, opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' }, dayOffset = 0): string {
  return new Date(2027, 5, 12 + dayOffset).toLocaleDateString(localeOf(lang), opts);
}
